import dayjs from 'dayjs'

import FileExclamationOutlinedIcon from '@ant-design/icons/FileExclamationOutlined'

import AvatarMui from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import CardActionArea from '@mui/material/CardActionArea'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import { alpha } from '@mui/material/styles'
import Typography from '@components/_mui/Typography'

export default function SOPNotification({ data, selected, onSelect }) {
  const sop = data.sopNotification.sop
  const testId = `sop-notification-${sop.title?.substring(0, 10)}`
  const unread = !data.readAt

  return (
    <CardActionArea
      onClick={onSelect}
      aria-current={selected || undefined}
      data-testid={testId}
      sx={[styles.card, selected && styles.selected, !unread && styles.read]}
    >
      <Stack direction="row" spacing={1.5} sx={{ alignItems: 'flex-start' }}>
        <File />
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography data-testid={`${testId}-content`} sx={{ fontWeight: unread ? 600 : 400 }}>
            {unread && <Box component="span" sx={styles.dot} />}
            Please review the latest updates to{' '}
            <b>
              {sop.title} (v.&nbsp;{sop.version})
            </b>
          </Typography>
          {data.sopNotification.createdAt && (
            <Typography variant="body2" data-testid={`${testId}-date`} sx={{ color: 'text.secondary', mt: 0.25 }}>
              {dayjs(data.sopNotification.createdAt).format('MMM D, hh:mm A')}
            </Typography>
          )}
        </Box>
      </Stack>
    </CardActionArea>
  )
}

SOPNotification.Loading = function Loading() {
  return (
    <Stack direction="row" spacing={1.5} sx={[styles.card, { alignItems: 'flex-start' }]}>
      <File />
      <Box sx={{ flex: 1 }}>
        <Typography>
          <Skeleton width="90%" />
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          <Skeleton width={100} />
        </Typography>
      </Box>
    </Stack>
  )
}

const File = () => (
  <AvatarMui sx={{ backgroundColor: 'background.default', boxShadow: (theme) => theme.customShadows.z2, color: 'text.primary' }}>
    <FileExclamationOutlinedIcon />
  </AvatarMui>
)

const styles = {
  card: {
    display: 'block',
    p: 1.5,
    borderRadius: 2.5,
    transition: (theme) => theme.transitions.create(['background-color', 'opacity'], { duration: theme.transitions.duration.shortest }),
    '&:hover': { bgcolor: 'action.hover' },
  },
  selected: {
    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.14),
    boxShadow: (theme) => `inset 0 0 0 1.5px ${alpha(theme.palette.primary.main, 0.5)}`,
    '&:hover': { bgcolor: (theme) => alpha(theme.palette.primary.main, 0.18) },
  },
  read: {
    opacity: 0.5,
  },
  dot: {
    display: 'inline-block',
    width: 7,
    height: 7,
    mr: 0.75,
    borderRadius: '50%',
    bgcolor: 'primary.main',
    verticalAlign: 'middle',
  },
}
